module.exports = __webpack_public_path__ + "img/logoSafariOrChrome.8b4e09f5.svg";